var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealtSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7134 17.9066L22.6667 16.9533L21.7134 15.9999L19.3334 18.3799L13.62 12.6666L16 10.2866L15.0467 9.33325L14.0934 10.2866L13.14 9.33325L11.7134 10.7599L10.76 9.80659L9.80671 10.7599L10.76 11.7133L9.33337 13.1399L10.2867 14.0933L9.33337 15.0466L10.2867 15.9999L12.6667 13.6199L18.38 19.3333L16 21.7133L16.9534 22.6666L17.9067 21.7133L18.86 22.6666L20.2867 21.2399L21.24 22.1933L22.1934 21.2399L21.24 20.2866L22.6667 18.8599L21.7134 17.9066Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealtSystem);
export default __webpack_public_path__ + "static/media/healtSystem.48d4b3575df0e4d89e89bc6ca721a15f.svg";
export { ForwardRef as ReactComponent };